import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";

/** The frame of the mail-link pages, laid out like /privacy and /terms. */
export function AccountPage({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">{title}</h1>

        {children}

        <div className="mt-12 pt-8 border-t border-gray-200">
          <Link to="/" className="text-purple-600 hover:text-purple-700 font-medium">
            ← Zurück zum Chat
          </Link>
        </div>
      </div>
    </div>
  );
}

/** Reads `?token=` from the mail link. */
export function validateTokenSearch(search: Record<string, unknown>): { token?: string } {
  return typeof search.token === "string" && search.token ? { token: search.token } : {};
}
